import Flickity from 'flickity';
import $ from 'jquery';

export default class PeopleGallery {
    static init() {
        this.setUpFlickity();
    }

    static setUpFlickity() {
        $('.js-people-gallery').each((index, element) => {
            this.gallery = new Flickity(element, {
                initialIndex: Math.floor(Math.random() * element.children.length),
                cellAlign: 'left',
                selectedAttraction: 0.15,
                friction: 0.7,
                wrapAround: true,
                pageDots: true,
                prevNextButtons: true,
                imagesLoaded: true,
            });

            this.flkty = Flickity.data($(element)[0]);

            setTimeout(() => this.flkty.resize(), 500);
        });
    }
}
